import { gql } from "@apollo/client"

export const GET_USERS_PARTICIPANTS = gql`
  query GetUsers($staff_id: ID!, $organization_id: ID!) {
    users(staff_id: $staff_id, organization_id: $organization_id) {
      staff_id
      staff_alias
      staff_name_first
      staff_name_last
      staff_email_address
      staff_role_name
    }

    allParticipants: participantAdvancedSearch(
      staff_id: $staff_id
      organization_id: $organization_id
      search_type: "all_participants"
    ) {
      participant_id
      participant_alias
      participant_name_first
      participant_name_last
      participant_email_account
      participant_membership_status
    }

    myParticipants: participantAdvancedSearch(
      staff_id: $staff_id
      organization_id: $organization_id
      search_type: "my_participants"
    ) {
      participant_id
      participant_alias
      participant_membership_status
    }
  }
`

export const GET_USERS_FROM_LIST = gql`
  query Users($list: [ID!]) {
    users: usersFromList(list: $list) {
      staff_id
      staff_alias
      staff_name_first
      staff_name_last
      staff_email_address
      staff_user_status
    }
  }
`

export const GET_ORGANIZATIONS = gql`
  query Organizations($staff_id: ID!) {
    organizations: getMyOrganizationsByUid(staff_id: $staff_id) {
      organization_id
      organization_alias
      organization_name
      enterprise_id
      enterprise_name
      organization_status
    }
  }
`
